import { trackGA4Event } from './ga4-shared';
import type { JobsLinkDestination } from './jobs-traffic-split';

export type PostJobCtaLocation = 'post_page' | 'keyword_suggestion' | 'category_popup';

export type ManageJobAdsCtaLocation = 'side_menu' | 'manage_ads_module';

interface JobsClickAndNavigateInput<TCtaLocation> {
    ctaLocation: TCtaLocation;
    linkDestination: JobsLinkDestination;
    href: string;
}

const JOBS_CLICK_NAVIGATION_TIMEOUT_MS = 1000;

function trackJobsClickAndNavigate<T extends GA4.ClickPostJob | GA4.ClickManageJobAds>(
    event: T,
    href: string
) {
    let hasNavigated = false;
    let timeoutId: ReturnType<typeof setTimeout>;

    const navigateOnce = () => {
        if (hasNavigated) return;

        hasNavigated = true;
        clearTimeout(timeoutId);
        window.location.href = href;
    };

    timeoutId = setTimeout(navigateOnce, JOBS_CLICK_NAVIGATION_TIMEOUT_MS);

    try {
        trackGA4Event({
            ...event,
            eventCallback: navigateOnce,
            eventTimeout: JOBS_CLICK_NAVIGATION_TIMEOUT_MS,
        });
    } catch {
        // The already-running timeout remains the navigation fallback when GTM is unavailable.
    }
}

export function trackPostJobClickAndNavigate({
    ctaLocation,
    linkDestination,
    href,
}: JobsClickAndNavigateInput<PostJobCtaLocation>) {
    trackJobsClickAndNavigate<GA4.ClickPostJob>(
        {
            event: 'click_post_job',
            ctaLocation,
            linkDestination,
        },
        href
    );
}

export function trackManageJobAdsClickAndNavigate({
    ctaLocation,
    linkDestination,
    href,
}: JobsClickAndNavigateInput<ManageJobAdsCtaLocation>) {
    trackJobsClickAndNavigate<GA4.ClickManageJobAds>(
        {
            event: 'click_manage_job_ads',
            ctaLocation,
            linkDestination,
        },
        href
    );
}
